import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Check } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Recruitment = () => {
  return (
    <section className="py-20 md:py-24 bg-white font-['Poppins']">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Image */}
            <div className="relative">
              <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800&q=80" 
                  alt="Professionnelle souriante" 
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Decorative elements */}
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#D4AF37]/20 rounded-2xl -z-10"></div>
              <div className="absolute -top-4 -left-4 w-20 h-20 bg-[#0A2320]/10 rounded-2xl -z-10"></div>
            </div>

            {/* Content */}
            <div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-[#153254]">
                Rejoignez l'aventure
              </h2>
              
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Vous êtes <span className="font-semibold text-[#0A2320]">auto-entrepreneur</span> et passionné par les services à la personne ? 
                <span className="font-semibold text-[#0A2320]"> The MajordHome</span> recherche des talents indépendants.
              </p>

              <div className="mb-8">
                <p className="text-base text-gray-500 mb-4">Nos domaines de collaboration :</p>
                <div className="flex flex-wrap gap-2">
                  {['Ménage', 'Bricolage', 'Jardinage', 'Nettoyage véhicule'].map((domain) => (
                    <span 
                      key={domain}
                      className="px-4 py-2 bg-[#F8FAF9] text-[#153254] rounded-xl text-sm font-medium border border-gray-100"
                    >
                      {domain}
                    </span>
                  ))}
                </div>
              </div>

              {/* Avantages avec icônes colorées */}
              <div className="space-y-4 mb-10">
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#D4AF37] to-[#e6c555] flex items-center justify-center flex-shrink-0 mt-0.5 shadow-md">
                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                  </div>
                  <p className="text-gray-700"><strong className="text-[#153254]">Liberté totale</strong> sur votre emploi du temps</p>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#0A2320] to-[#1a4a45] flex items-center justify-center flex-shrink-0 mt-0.5 shadow-md">
                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                  </div>
                  <p className="text-gray-700"><strong className="text-[#153254]">Missions régulières</strong> et clientèle fidèle</p>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#D4AF37] to-[#c9a030] flex items-center justify-center flex-shrink-0 mt-0.5 shadow-md">
                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                  </div>
                  <p className="text-gray-700"><strong className="text-[#153254]">Accompagnement</strong> à la création de statut si besoin</p>
                </div>
              </div>

              <Link to="/candidature" onClick={() => window.scrollTo(0, 0)} className="block">
                <Button 
                  className="w-full sm:w-auto bg-[#0A2320] hover:bg-[#0d2e2a] text-white font-semibold text-sm md:text-base px-6 py-3 md:px-8 md:py-4 rounded-xl shadow-xl transition-all hover:-translate-y-1"
                >
                  Déposer ma candidature
                  <ArrowRight className="ml-2 h-4 w-4 md:h-5 md:w-5" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
